import { Link, Stack, Step, StepLabel, Stepper, Typography } from "@mui/material";
import moment from "moment";
import { useState } from "react";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import DisplayEmptyListAction from "../../../../../../components/DisplayEmptyListAction";
import useSetParamsURL from "../../../../../../lib/useSetParamsURL";
import { formatarValorMonetario } from "../../../../../../helpers/masks";
import { TitulosPagarRelacionados } from "../../../../../../types/api/financeiro/detalhar-titulo-pagar";

export default function TitulosRelacionados({ codigo, relacionados }: TitulosRelacionadosProps) {

    const { setParamsUrl } = useSetParamsURL()

    //funçoes manipuladoras
    const handleCalStep = () => {
        if (!relacionados) return 0
        return relacionados.findIndex(item => item.id === codigo)
    }
    //

    const [activeStep] = useState(handleCalStep());

    return (
        <>
            {
                !relacionados &&
                <DisplayEmptyListAction
                    disabled
                    label="Nenhum título relacionado"
                />
            }

            {
                relacionados &&
                <Stepper activeStep={activeStep} orientation="vertical">
                    {
                        relacionados.map((step) => {
                            const status = !step.data_pagamento ? "Em aberto" : "Pago"

                            return (
                                <Step key={step.codigo} completed={false}>
                                    <StepLabel
                                        optional={
                                            <Stack direction="column">
                                                <Typography variant="caption">{`Saldo: ${formatarValorMonetario(step.saldo_titulo)}`}</Typography>
                                                <Stack direction="row" alignItems="center" gap={0.5}>
                                                    <CalendarMonthIcon sx={{ fontSize: 12, mt: -0.3 }} />
                                                    <Typography variant="caption">{`${moment(step.vencimento).format("DD/MM/YYYY")} - ${status}`}</Typography>
                                                </Stack>
                                            </Stack>
                                        }
                                    >
                                        <Typography variant="subtitle2">
                                            <Link
                                                onClick={() => {
                                                    setParamsUrl(step.id, "detalhe-titulo-pagar")
                                                }}
                                                sx={{ cursor: "pointer" }}
                                            >
                                                {step.codigo}
                                            </Link>
                                        </Typography>
                                    </StepLabel>
                                </Step>
                            )
                        })
                    }
                </Stepper>
            }
        </>
    )
}

interface TitulosRelacionadosProps {
    codigo: string;
    relacionados: TitulosPagarRelacionados[] | null
}